import { useEffect, useRef } from "react";

export function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(entries => {
      entries.forEach((e, i) => {
        if (e.isIntersecting) {
          e.target.style.transitionDelay = `${i * 90}ms`;
          e.target.classList.add("on");
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.08, rootMargin: "0px 0px -40px 0px" });
    el.querySelectorAll(".rv,.rv2,.rv3").forEach(item => obs.observe(item));
    if (el.classList.contains("rv") || el.classList.contains("rv2") || el.classList.contains("rv3"))
      obs.observe(el);
    return () => obs.disconnect();
  }, []);
  return ref;
}
